var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgCode)?_c('svg',{class:['p-icon', {'p-icon--hover': _vm.hover}],style:(_vm.style),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.computedViewBox,"role":"img","width":_vm.width,"height":_vm.height},domProps:{"innerHTML":_vm._s(_vm.svgCode)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }